import { render } from "./StaffSidebar.vue?vue&type=template&id=8ccb16d0&scoped=true"
import script from "./StaffSidebar.vue?vue&type=script&lang=js"
export * from "./StaffSidebar.vue?vue&type=script&lang=js"

import "./StaffSidebar.vue?vue&type=style&index=0&id=8ccb16d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ccb16d0"]])

export default __exports__